<template>
  <div id="bloodevent">
    <div class="blood_center">
      <img class="blood_top blood_pc" src="../assets/img/bloodevent/pc_1.jpg" alt="">
      <img class="blood_mobile" src="../assets/img/bloodevent/mobile_1.jpg" alt="">
      <div class="blood_mid_wrap">
        <img class="blood_mid" src="../assets/img/bloodevent/2.jpg" alt="">
      </div>
      <img class="blood_button1" src="../assets/img/bloodevent/blood_button1.jpg"
        @click="goToDetail('L-2023220-1676865317720','L')" alt="">
      <img class="blood_middle blood_pc" src="../assets/img/bloodevent/pc_2.jpg" alt="">
      <img class="blood_mobile" src="../assets/img/bloodevent/mobile_2.jpg" alt="">
      <img class="blood_button1" src="../assets/img/bloodevent/blood_button2.jpg"
        @click="goToDetail('L-2023220-1676865317720','L')" alt="">
      <img class="blood_bottom blood_pc" src="../assets/img/bloodevent/pc_3.jpg" alt="">
      <img class="blood_mobile" src="../assets/img/bloodevent/mobile_3.jpg" alt="">

      <img class="blood_button1" src="../assets/img/bloodevent/blood_button1.jpg"
        @click="goToDetail('L-2023220-1676865317720','L')" alt="">

    </div>
  </div>

</template>

<script>
  export default {
    created() {
    },
    computed: {
    },
    methods: {
      goToDetail(productId, salesRoute) {
        this.$router.push({ path: '/detail', query: { productId: productId, salesRoute: salesRoute } });
      }
    },
    mounted() {
    }
  }

</script>

<style scoped>
  #bloodevent {
    margin-top: -6rem;
  }
  .blood_center {
    text-align: center;
    margin: 0 auto;
  }
  .blood_top {
    width: 100%;
    height: auto;
  }
  .blood_button1 {
    width: 30%;
    margin-top: 50px;
    cursor: pointer;
    transition: all 0.2s;
    margin-bottom: 50px;
  }
  .blood_button1:hover {
    scale: 1.05;
  }
  .blood_middle {
    width: 100%;
    height: auto;
    margin-top: 25px;
  }
  .blood_bottom {
    width: 100%;
    height: auto;
    margin-top: 50px;
  }

  .blood_mobile {
    display: none;
  }

  .blood_mid {
    width: 40%;
  }

  .blood_mid_wrap {
    padding: 80px 0px 0px 0px;
  }

  @media(max-width:1024px) {
    #bloodevent {
      margin-top: 2rem;
    }

    .blood_mobile {
      width: 100%;
      height: auto;
      display: block;
    }

    .blood_button1 {
      width: 85%;
      margin: 20px 0 10px 0;
    }

    .blood_pc {
      display: none;
    }

    .blood_mid {
      margin: 0 auto;
      width: 95%;
    }

    .blood_mid_wrap {
      padding: 10px 0px;
    }
  }
</style>